import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { IconButtonWithTooltip } from "@remo-co/ui-core/src/components/IconButtonWithTooltip";
import { Edit } from "@remo-co/ui-core/src/icons/Edit";
import { useI18n } from "i18n";
import {
  PAGES,
  TRACKING_CONTEXT,
  usePageTracking,
  Events,
} from "modules/tracking";
import { useContext, useEffect } from "react";
import { selectMagicLinkEmail } from "modules/auth/redux/selectors";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import useQueryParams from "modules/queryParams/hooks/useQueryParams";
import { NeedHelpChatButton } from "modules/helpChat/components/NeedHelpChatButton";
import AuthButton from "modules/auth/authButtons/AuthButton";
import AuthViewContainer from "../../layout/AuthViewContainer";
import MagicWandSVG from "../../assets/magic-wand.svg";
import { useStyles } from "./styles";

const CheckEmailToLogin = () => {
  const { track } = useContext(TRACKING_CONTEXT);
  const { t } = useI18n(["auth"]);
  const { push, goBack } = useHistory();
  const magicLinkEmail = useSelector(selectMagicLinkEmail);
  const { mode } = useQueryParams();
  const styles = useStyles();

  usePageTracking(PAGES.MAGIC_LINK_CHECK_EMAIL);

  useEffect(() => {
    if (!magicLinkEmail) {
      push("/signin");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goBackToLogin = () => {
    track(Events.MAGIC_LINK_BACK_TO_LOGIN_CLICKED);
    goBack();
  };
  const changeEmail = () => {
    track(Events.MAGIC_LINK_CHANGE_EMAIL_CLICKED);
    goBack();
  };

  return (
    <AuthViewContainer>
      <Box className={styles.container}>
        <img
          alt={t(`auth:check.email.to.login.header.${mode || "default"}`)}
          className={styles.magicWand}
          src={MagicWandSVG}
        />
        <Typography variant="h2">
          {t(`auth:check.email.to.login.header.${mode || "default"}`)}
        </Typography>
        <Box className={styles.magicLinkContainer}>
          <Typography variant="body1">
            {t("auth:sent.magic.link.email")} <b>{magicLinkEmail}</b>{" "}
            <IconButtonWithTooltip
              title={t("auth:change.email")}
              aria-label={t("auth:change.email")}
              id="edit-email-button"
              data-testid="edit-email-button"
              onClick={changeEmail}
              size="small"
              className={styles.changeEmailButton}
            >
              <Edit />
            </IconButtonWithTooltip>
          </Typography>
          <Typography>
            {t(`auth:click.magic.link.email.${mode || "default"}`)}
          </Typography>
        </Box>
        <Typography variant="body1">{t("auth:check.spam.folder")}</Typography>
        <div className={styles.emailDetails}>
          <Typography>
            <b>{t("auth:check.email.subject")}</b>{" "}
            {t("auth:magic.link.subject")}
          </Typography>
          <Typography>
            <b>{t("auth:check.email.from")}</b> {t("auth:magic.link.from")}
          </Typography>
        </div>
        <div>
          <AuthButton
            aria-label={t("auth:login.with.anonymous")}
            onClick={goBackToLogin}
            color="dark"
            data-testid="back-to-login-button"
            variant="tertiary"
            fullWidth={false}
          >
            {t("auth:back.to.login")}
          </AuthButton>
          <NeedHelpChatButton />
        </div>
      </Box>
    </AuthViewContainer>
  );
};

export default CheckEmailToLogin;
